<div class="u4-card"
     [attr.id]="id"
     [class.disabled]="disabled"
     [routerLink]="link"
     (keydown.enter)="$event.target.click()">
  <div class="u4-card__image">
    <ng-content select="[card-image]"></ng-content>
  </div>
  <div class="u4-card__title-wrapper">
    <div class="u4-card__title">
      <h4>{{ title }}</h4>
    </div>
    <div class="u4-card__subtitle" *ngIf="subtitle">
      {{ subtitle }}
    </div>
  </div>
  <div class="u4-card__body">
    <ng-container *ngIf="body">{{ body }}</ng-container>
    <ng-content select="[card-body]" *ngIf="!body"></ng-content>
  </div>
  <div class="u4-card__footer" *ngIf="footer">
    <div class="u4-card__actions">
      <ng-content select="[card-actions]"></ng-content>
    </div>
    <div class="u4-card__toolbar">
      <ng-content select="[card-toolbar]"></ng-content>
    </div>
  </div>
</div>
